module.exports = __webpack_public_path__ + "img/far_day_cyl75_axis0.0960a969.jpg";